/* Set up using Vue 3 */
import { createApp, h } from "vue";
import App from "./App.vue";
import { VueFire, VueFireAuth } from "vuefire";
import { app as firebaseApp } from "./firebase";
import posthogPlugin from "./plugins/userst";
import { ThemeProvider } from "@vue-styled-components/core";
import { theme } from "./themes/baseTheme";
import sentryPlugin from "./plugins/sentry";

import "./assets/main.css";
import "./assets/printStyles.scss";

import router from "./router";
import { initIcons } from "./icons";

// Create the app instance using a render function to wrap with ThemeProvider
export const app = createApp({
  render: () => h(ThemeProvider, { theme: theme }, () => h(App)),
});

initIcons();

app.use(router);

// Initialize Sentry (must come after router is created so that tracing can hook in)
app.use(sentryPlugin);

app.use(posthogPlugin);
app.use(VueFire, {
  firebaseApp,
  modules: [VueFireAuth()],
});

app.mount("#app");
